const params = (entries: any) => {
    const result: any = {};
    for (const entry of entries) {
        const [key, value] = entry;
        result[key] = value;
    }
    return result;
};

const parseUrlParams = () => {
    return params(new URL(document.location.toString()).searchParams.entries());
};

export default parseUrlParams;
